var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7482 10.0662C18.5429 10.0662 19.2052 10.0662 19.9999 10.0662C20.1323 12.5828 18.8078 16.5563 14.9668 18.8079C12.8476 19.8675 10.5959 20.2649 8.34424 19.8675C5.96014 19.4702 4.10583 18.2781 2.51643 16.5563C1.72173 17.351 0.927026 18.1457 0.132324 18.9404C0.132324 16.6887 0.132324 14.4371 0.132324 12.3179C2.38398 12.3179 4.50318 12.3179 6.75484 12.3179C5.82769 13.245 5.03299 14.0397 4.10583 14.9669C5.56279 16.8212 8.21179 18.2781 11.3906 17.8808C13.2449 17.6159 14.8343 16.6887 16.1588 15.2318C17.2184 13.6424 17.7482 11.9205 17.7482 10.0662Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25166 10.0662C1.45695 10.0662 0.794702 10.0662 0 10.0662C0 8.74173 0.264901 7.54968 0.794702 6.22517C1.5894 4.10597 3.04636 2.51657 4.90066 1.32451C8.87417 -1.05959 14.1722 -0.397341 17.6159 3.44372C18.4106 2.64902 19.2053 1.85431 20 1.05961C20 3.31127 20 5.43047 20 7.68213C17.7483 7.68213 15.6291 7.68213 13.3775 7.68213C14.3046 6.75498 15.0993 5.96027 16.0265 5.03312C14.5695 3.17882 11.9205 1.85431 8.87417 2.25167C7.01987 2.64902 5.43046 3.44372 4.10596 4.90067C2.91391 6.35763 2.25166 8.07948 2.25166 10.0662Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.e74199abe8dc0a73d4bf8f552c2212a7.svg";
export { ForwardRef as ReactComponent };